import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AxiosUrl from "../../../AxiosUrl";
import styles from "./DeliveryCharge.module.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  bgcolor: "background.paper",
  border: "2px solid #00000038",
  boxShadow: 24,
  p: 2,
  maxHeight: "95vh",
  overflowY: "auto",
  "@media (min-width: 600px)": {
    width: 400,
  },
};

function DeliveryChargeModal({ setDeliveryModal, setRefresh, Refresh, Data }) {
  const [Dhaka, setDhaka] = useState(Data?.Dhaka || "");
  const [Outside, setOutside] = useState(Data?.Outside || "");
  const [loading, setLoading] = useState(false);
  const uid = localStorage.getItem("id");

  const fromData = {
    uid,
    Dhaka,
    Outside,
  };

  const submitDomain = () => {
    setLoading(true);
    if (!Dhaka || !Outside) {
      setLoading(false);
      return toast.error("All fields are required");
    }

    AxiosUrl.post(`/update-domain-new/${uid}`, fromData)
      .then(() => {
        setRefresh(Refresh + 1);
        setDeliveryModal(false);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error.response.data);
        setLoading(false);
      });
  };

  return (
    <Modal
      open={setDeliveryModal}
      onClose={() => setDeliveryModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableScrollLock={true}
    >
      <Box sx={style}>
        <ToastContainer />
        <div className={styles.titleCloseBtn} style={{ textAlign: "right" }}>
          <Button
            onClick={() => setDeliveryModal(false)}
            style={{ color: "red" }}
          >
            X
          </Button>
        </div>

        <div className={styles.title}>
          <Box sx={{ width: "100%", marginBottom: "10px" }}>
            <TextField
              placeholder="Delivery Charge Dhaka"
              fullWidth
              label="Delivery Charge Dhaka"
              onChange={(e) => setDhaka(e.target.value)}
              value={Dhaka}
            />
          </Box>

          <Box sx={{ width: "100%", marginTop: "15px" }}>
            <TextField
              placeholder="Delivery Charge Outside"
              fullWidth
              label="Delivery Charge Outside"
              onChange={(e) => setOutside(e.target.value)}
              value={Outside}
            />
          </Box>
        </div>

        <div style={{ marginTop: 20, textAlign: "right" }}>
          <Button
            onClick={() => setDeliveryModal(false)}
            variant="outlined"
            style={{ marginRight: 10 }}
          >
            Cancel
          </Button>
          <Button onClick={submitDomain} variant="contained" disabled={loading}>
            {loading ? "Loading.." : "Continue"}
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

export default DeliveryChargeModal;
